import React from "react";

interface IFormErrorProps {
  errorMessage: string | undefined;
}

export const FormError: React.FC<IFormErrorProps> = ({ errorMessage }) => <span className="errorMessage">* {errorMessage}</span>;
